import { useQuery } from "@tanstack/react-query";

import { ConstellationAPI } from "../infrastructure/api/Constellation.api";

/**
 * Whether a session has constellation work in it: a board launched for it,
 * or snapshots taken of one. What decides whether the session page gives the
 * constellation a tab of its own — a session that never had a board has
 * nothing to show there.
 */
export function useSessionConstellation(sessionId: string | undefined) {
    const summary = useQuery({
        queryKey: ["constellation-session-summary", sessionId],
        queryFn: async () => (await ConstellationAPI.getSessionBoardSummary(sessionId as string)).data,
        enabled: Boolean(sessionId),
        retry: false,
    });
    const snapshots = useQuery({
        queryKey: ["constellation-session-snapshot-count", sessionId],
        queryFn: async () => (await ConstellationAPI.getSessionSnapshotCount(sessionId as string)).data.count ?? 0,
        enabled: Boolean(sessionId),
        retry: false,
    });

    return {
        hasConstellation: Boolean(summary.data?.has_board) || (snapshots.data ?? 0) > 0,
        loading: summary.isLoading || snapshots.isLoading,
    };
}
